export enum PricingPlans {
  NO_ACTIVE_SUBSCRIPTION = 'NO_ACTIVE_SUBSCRIPTION',
  PRO_PLUS = 'PRO_PLUS',
  PRO = 'PRO',
  STARTER = 'STARTER',
  LITE = 'LITE'
}

export const PricingPlanNames: Record<PricingPlans, string> = {
  NO_ACTIVE_SUBSCRIPTION: 'Free',
  PRO: 'Pro',
  PRO_PLUS: 'Pro Plus',
  STARTER: 'Starter',
  LITE: 'Lite'
};

export enum PlanWarnings {
  NONE = 'NONE',
  UPLOAD_LIMIT = 'UPLOAD_LIMIT',
  UPGRADE_TRIAL = 'UPGRADE_TRIAL',
  RENEW_PLAN = 'RENEW_PLAN',
  EXPIRED_PLAN = 'EXPIRED_PLAN',
  LABEL_CLICK = 'LABEL_CLICK',
  LAUNCH_MESSAGE = 'LAUNCH_MESSAGE',
  FEATURE_LIMIT_EXCEEDED = 'FEATURE_LIMIT_EXCEEDED'
}

export const PlanWarningsCTALabels: Record<PlanWarnings, string> = {
  NONE: '',
  UPLOAD_LIMIT: 'upgrade now',
  UPGRADE_TRIAL: 'upgrade now',
  RENEW_PLAN: 'renew now',
  EXPIRED_PLAN: 'upgrade now',
  LABEL_CLICK: '',
  LAUNCH_MESSAGE: 'here',
  FEATURE_LIMIT_EXCEEDED: 'Upgrade'
};
